export const filterConstants = {
    UPDATE_FILTER: 'UPDATE_FILTER',
    UPDATE_DICT: 'UPDATE_DICT',
    CLEAR_DICT: 'CLEAR_DICT',
    UPDATE_ERROR: 'UPDATE_ERROR',
};
